import { eapCategoriesQuery } from "@/api/listings";
import { mySupportersQuery } from "@/api/me";
import { Box, Flex, Span } from "@givenwell/components";
import { CheckCircleIcon, CloseCircleIcon } from "@givenwell/core-solid-icons";
import { colors } from "@givenwell/theme";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_app/claims/policy/eap")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data: mySupporters } = useSuspenseQuery(mySupportersQuery());
  const { data: eapCategoriesData } = useSuspenseQuery(eapCategoriesQuery);

  const coveredCategoryIds = new Set(mySupporters.supporters.flatMap(s => s.eap?.covered_category_ids || []));
  const sortedSubcategories = [...eapCategoriesData.subcategories].sort((a, b) => {
    const aCovered = coveredCategoryIds.has(a.category_id) ? 0 : 1;
    const bCovered = coveredCategoryIds.has(b.category_id) ? 0 : 1;
    if (aCovered !== bCovered) return aCovered - bCovered;
    return a.name.localeCompare(b.name);
  });
  const hasAnyCovered = sortedSubcategories.some(c => coveredCategoryIds.has(c.category_id));

  return (
    <>
      {hasAnyCovered && (
        <>
          <p>This is your employer’s current policy of what can and can't be claimed for a free session: </p>
          <Box css={{ spaceY: 8, columnCount: 2 }}>
            {sortedSubcategories.map(c => {
              const covered = coveredCategoryIds.has(c.category_id);
              return (
                <Flex key={c.category_id} css={{ items: "stretch", gap: 8 }}>
                  <Flex css={{ alignItems: "start" }}>
                    {covered ? (
                      <CheckCircleIcon style={{ flexShrink: 0, color: colors.green500 }} />
                    ) : (
                      <CloseCircleIcon style={{ flexShrink: 0, color: colors.gray }} />
                    )}
                  </Flex>
                  <Flex css={{ items: "center" }}>
                    <Span css={{ color: covered ? undefined : colors.text2 }}>{c.name}</Span>
                  </Flex>
                </Flex>
              );
            })}
          </Box>
        </>
      )}
      <p>
        Coverage may be subject to change. If you want to make sure something qualifies before you book an appointment,
        please reach out to us at{" "}
        <a href="mailto:claims@givenwell.com">
          <Span css={{ color: colors.blue600, weight: 500 }}>claims@givenwell.com</Span>
        </a>
        .
      </p>
    </>
  );
}
